export default __webpack_public_path__ + "static/media/product02.d47cbaf9.jpg";